import { defineMessages } from 'react-intl';

export default defineMessages({
  close: {
    id: 'roomi.dialog.close',
    defaultMessage: 'Close'
  }
});
